import React from 'react'
import './../../App.css'
import './projectstart.css'
import Projectstartimg from './../../Images/project-start1-1144cf3a1b18070155dc90c8a7f97091 (1).png'
import circleimg from './../../Images/circle-shape1-84499f1a9f5baf6107753940a219d149.png'
export default function Projectstart(props) {
  return (
      <section className="home_section-5 ptb-100">
          <div className="container">
              <div className="row">
                  <div className="col-lg-6 col-md-12">
                      <img src={Projectstartimg}/>
                  </div>
                  <div className="col-lg-6 col-md-12">
                      <div className="home_section-5_content">
                          <h1>{props.Projecttitle}</h1>
                          <p style={{ marginBottom: "20px" }}>{props.projectdescription}</p>
                          <div className="home_section-5_button">
                              <a href="#" className='button'>{props.projectbtntext}</a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div className="circle_img_main">
              <img src={circleimg} />
          </div>
      </section>
  )
}
